import { render, staticRenderFns } from "./ChatRating.vue?vue&type=template&id=94859bb6&scoped=true"
import script from "./ChatRating.vue?vue&type=script&lang=ts"
export * from "./ChatRating.vue?vue&type=script&lang=ts"
import style0 from "./ChatRating.vue?vue&type=style&index=0&id=94859bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94859bb6",
  null
  
)

export default component.exports